import { RefreshIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const RefreshCw = /* @__PURE__ */ createIcon(RefreshIcon, 'RefreshCw');
